import React, { useRef, useState } from "react";
import { Mic, Square, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export const VoiceButton = ({ onText, testid = "voice-btn", url = "/teacher/diary/voice" }) => {
  const [state, setState] = useState("idle");
  const rec = useRef(null);
  const chunks = useRef([]);

  const start = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const mime = MediaRecorder.isTypeSupported("audio/webm") ? "audio/webm" : "audio/mp4";
      const mr = new MediaRecorder(stream, { mimeType: mime });
      chunks.current = [];
      mr.ondataavailable = (e) => { if (e.data.size) chunks.current.push(e.data); };
      mr.onstop = async () => {
        stream.getTracks().forEach((t) => t.stop());
        setState("busy");
        const blob = new Blob(chunks.current, { type: mime });
        const fd = new FormData();
        fd.append("audio", blob, mime === "audio/webm" ? "voice.webm" : "voice.mp4");
        try {
          const { data } = await api.post(url, fd);
          onText(data.text);
        } catch (e) {
          toast.error(e?.response?.data?.detail || "Could not convert the voice note");
        } finally { setState("idle"); }
      };
      mr.start();
      rec.current = mr;
      setState("rec");
      setTimeout(() => { if (rec.current?.state === "recording") rec.current.stop(); }, 60000);
    } catch {
      toast.error("Allow microphone access to use voice notes");
    }
  };

  const stop = () => rec.current?.state === "recording" && rec.current.stop();
  const cls = state === "rec" ? "bg-red-600 text-white animate-pulse" : "bg-violet-100 text-violet-800 hover:bg-violet-200";
  return (
    <button type="button" onClick={state === "rec" ? stop : start} disabled={state === "busy"}
      className={`inline-flex h-10 items-center gap-1.5 rounded-full px-4 text-sm font-semibold transition-colors ${cls}`} data-testid={testid}>
      {state === "busy" ? <Loader2 className="h-4 w-4 animate-spin" /> : state === "rec" ? <Square className="h-4 w-4" /> : <Mic className="h-4 w-4" />}
      {state === "busy" ? "Writing…" : state === "rec" ? "Stop" : "Speak"}
    </button>
  );
};

export const VoiceRecorder = VoiceButton;
